import { Outlet } from "react-router-dom";
import Header from "../../header/header";
import ProtectedRoute from "../../protected-route/protected-route";

const MainLayout = () => {
	return (
		<ProtectedRoute>
			<div className="grid-container">
				<Header />
				<Outlet />
			</div>
		</ProtectedRoute>
	);
};

export default MainLayout;